<template>
<div id="app">
  <default-layout></default-layout>
  <whats-app v-if="siteName !== 'ingressoparatodos.com.br'"></whats-app>
</div>
</template>

<script>
import DefaultLayout from "@/views/Main.vue"
import vueAlert from 'vue-sweetalert2';
import config from "@/config";
import Vue from "vue"
import WhatsApp from './views/WhatsApp.vue'
import vSelect from "vue-select"
Vue.component("v-select", vSelect)
import "vue-select/dist/vue-select.css";

export default {
  name: 'App',

  components: {
    DefaultLayout,
    WhatsApp
  },
  data() {
    return {
      refreshing: false,
      registration: null,
      updateExists: false,
      siteName: config.info.siteName
    };
  },
  computed: {
    
  },
  created() {
    // Listen for swUpdated event and display refresh snackbar as required.
    document.addEventListener('swUpdated', this.showRefreshUI, { once: true });
    // Refresh all open app tabs when a new service worker is installed.
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (this.refreshing) return;
      this.refreshing = true;
      // window.location.reload();
    });
  },
  mounted() {
    // importando google icons
    const googleIcon = document.createElement('link')
    googleIcon.setAttribute('rel', 'stylesheet')
    googleIcon.setAttribute('href', 'https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@48,400,1,0')
    document.head.appendChild(googleIcon)
  },
  methods: {
    toastSuccess(message, timer = 4000, showbutton = false) {
      this.$swal({
        type: 'success',
        toast: true,
        text: message,
        position: 'top-end',
        customClass: 'alert__tixsme alert__sucess',
        background: '#333',
        timer: timer,
        showConfirmButton: showbutton,
      });
    },
    showRefreshUI (e) {
      this.registration = e.detail;
      this.updateExists = true;
      // this.$swal({
      //   title: 'Nova versão',
      //   text: "Realizamos atualizações no site, iremos atualizar agora.",
      //   type: 'success',
      //   toast: true,
      //   position: 'top-end',
      //   customClass: 'alert__tixsme alert__sucess',
      //   background: '#333',
      //   showConfirmButton: false,
      //   timer: 4000,
      // }).then((result) => {
      //   this.refreshApp();
      // });
      this.refreshApp();
      //this.toastSuccess("Realizamos atualizações no site, iremos atualizar agora.");
    },
    refreshApp () {
      this.updateExists = false;
      if (!this.registration || !this.registration.waiting) { return; }
      this.registration.waiting.postMessage('skipWaiting');
    },
  },
  computed: {
    component() {
      return this.$store.state.common.layout
    }
  }
}
</script>

<style lang="scss">
@media screen and (max-width: 500px) {
  .wrapper_login { // prevent zoom on mobile while typing in input fields
    input[type='text'],
    input[type='number'],
    input {
      font-size: 16px !important;
    }
  }
}
</style>
